module.exports = __webpack_public_path__ + "73e9a5c66aaca97cc58129117ac5a0cc.png";